import React from "react";

const Privacy = () => {
  return (
    <section className="ls s-py-150 s-py-md-150 s-py-lg-150">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row align-items-center justify-content-center mt-50">
              <div className="left-content col-10 texto-largo">
                <div className="divider-30 d-none d-lg-block"></div>
                <h4 className="mt-0">Privacy Policy</h4>
                <div className="divider-30 d-none d-xl-block"></div>

                <p>
                  Fyxme LLC. and its affiliates take your privacy seriously.
                  This Privacy Policy explains how we collect, use, share, and
                  protect each and every client's Personal Information. If you
                  do not want your Personal Information handled in this manner,
                  please do not use the Fyxme LLC Site. Personal Information is
                  information that could be used to identify an individual, such
                  as your name, Phone number, and e-mail address.
                </p>
                <p>
                  This Privacy Policy applies only to information that we
                  collect on Fyxme.com and through Fyxme LLC mobile app Site,
                  including the mobile application for service requesters and
                  the mobile application for service professionals
                  (the&nbsp;"App") (collectively the&nbsp;"Fyxme.com").
                </p>
                <p>
                  Any information you provide through Fyxme LLC site, including
                  any Personal Information, will be transferred to and processed
                  by computer servers located within the United States.
                </p>
                <h5>a) Information We Collect</h5>
                <p>
                  We collect information that you voluntarily provide through
                  the Fyxme LLC Site.
                </p>
                <p>
                  If you are using the Fyxme LLC site request services, you may
                  give us:
                </p>
                <ol>
                  <li>
                    Personal information, such as your full name, repair
                    location, address, telephone&nbsp;number, and email address
                  </li>
                  <li>
                    If you participate on the Fyxme LLC Site&nbsp;as a
                    third-party service professional, you may need&nbsp;to
                    provide us with:
                    <br /> A) Contact information, such as your full name,
                    email, address, and phone number
                  </li>
                  <li>
                    Application information, if requesting to become a third
                    party contractor professional through the Fyxme LLC site we
                    may ask things such as; your experience, skills, eligibility
                    to work, and availability
                    <br /> A) If you are a service professional who wishes to
                    participate in servicing in the United States and you are
                    selected you will need to provide social security for a
                    background check
                  </li>
                  <li>
                    If you apply as a contractor form for employment with Fyxme
                    LLC, you will need to provide us with:
                    <br /> Contact information, including your name, email
                    address, telephone number, and mailing address, resume.
                  </li>
                </ol>
                <h5>b) Information We Collect Through Technology</h5>
                <p>
                  We collect information through technology to better serve you.
                  When you access and use the Fyxme LLC site, in some cases, our
                  third-party service providers collect information about how
                  you interact with the Fyxme LLC site. We describe below a few
                  of the methods we use to collect information through
                  technology.
                </p>
                <p>
                  When you visit the Fyxme LLC site, we collect your Internet
                  Protocol (IP) address. An IP address is often associated with
                  the portal you used to enter the Internet, like your Internet
                  service provider (ISP), company, association, or university.
                  While an IP address may reveal your ISP or geographic area, we
                  cannot determine your identity solely based upon your IP
                  address. However, we may link the last IP address you used to
                  access the Fyxme LLC Site to match Personal Information you
                  provide us.
                </p>
                <p>
                  We may also collect a unique identifier for your computer,
                  mobile device, or other device used to access the Fyxme LLC
                  Site. A Device Identifier is a number that is automatically
                  assigned to the device you used to access the Fyxme LLC site.
                  We may link the Device Identifier to other information about
                  your visit, such as what pages you viewed, and to Personal
                  Information you provide us, such as your name.
                </p>
                <p>
                  <strong>Do We Use Cookies?</strong>
                  <br /> Yes. Cookies are a small piece of text sent to your
                  browser by a website you visit, it helps the website to
                  remember information about your visit, like your preferred
                  language and other settings.
                </p>
                <p>
                  <strong>Web Beacons</strong>
                  <br /> We may include small graphic images or other web
                  programming code, called web beacons (also known as "pixel
                  tags", "web bugs" or "clear GIFs"), in our web and mobile
                  pages and messages. The web beacons are minute graphics with a
                  unique identifier. They are used to track the online movements
                  of Web users. In contrast to cookies, which are stored in a
                  user's computer hard drive, web beacons are embedded invisibly
                  on Web pages and are about the size of the period at the end
                  of this sentence. Web beacons help us better manage content on
                  the Fyxme LLC Site by informing us what content is effective,
                  monitoring how users navigate the Site, counting users of the
                  Fyxme LLC Site, and counting how many e-mails sent by us were
                  actually opened.
                </p>
                <p>
                  <strong>Your 'Do Not Track' Browser Setting</strong>
                  <br /> We do not support the Do Not Track (DNT) browser
                  setting. DNT is a preference you can set in your browser's
                  settings to let the websites you visit know that you do not
                  want the websites collecting your Personal Information.
                </p>
                <p>
                  We do track your online activities over time and across
                  third-party websites or online services. For example, we use
                  web beacons to help us determine what links or advertisers
                  brought you to our Site. We also use third-party service
                  providers to display advertisements to you on other websites
                  based on your activities while on the Fyxme LLC Site.
                </p>

                <h5>c) Information Collected by Mobile Applications</h5>
                <p>
                  When you use the App, the App may automatically collect and
                  store some or all of the following information from your
                  mobile device ("Mobile Device Information"), including, but
                  not limited to:
                </p>
                <ul>
                  <li>The type of Internet browsers you use with the App.</li>
                  <li>Your preferred country.</li>
                  <li>Your mobile operating system.</li>
                  <li>
                    Your phone number or other identifiers assigned to your
                    mobile device, including: The IP address of your mobile
                    device, The manufacturer and model of your mobile device
                  </li>
                </ul>
                <p>
                  We may also collect information about how you use the App,
                  such as the amount of time you spend using the App, how many
                  times you use a specific feature of the App over a given time
                  period, how often you use the App, and actions you take in the
                  App. In addition, we may gather information about the website
                  from which you downloaded the App to help us determine what
                  App download site is most effective (collectively&nbsp;"App
                  Usage Information").
                </p>
                <p>
                  We may link your Mobile Device Information and App Usage
                  Information to Personal Information you have provided us, in
                  which case we will treat the combined information as Personal
                  Information.
                </p>
                <p>
                  <strong>Location Tracking</strong>
                  <br /> If you are a service professional using Fyxme LLC
                  mobile app. for service professionals (the&nbsp;"Pro Portal"),
                  we may collect your geographic location by using Global
                  Positioning System (GPS) information sent to us from the Pro
                  Portal. For more information on when this information is
                  collected, how we use it, and with whom it is shared, services
                  professionals should refer to the Service Professional
                  Agreement available on the service professional portal.
                </p>
                <p>
                  We only collect location information about service
                  professionals who have been accepted to participate with Fyxme
                  LLC. and not about service requesters or about service
                  professionals applying to participate with Fyxme.
                </p>

                <h5>d) Information You Provide About A Third Party</h5>
                <p>
                  If you choose to use our referral service to tell a friend
                  about the service, we may collect your friend's name and email
                  address. We will automatically send your friend an email
                  inviting him or her to visit the Fyxme LLC. We do not use this
                  information for any other marketing purpose unless we obtain
                  consent from that person or we explicitly say otherwise.
                  Please be aware that when you refer a friend, your e-mail
                  address may be included in the message sent to your friend.
                </p>
                <h5>e) Information Third Parties Provide About You</h5>
                <p>
                  We may supplement the information we collect about you through
                  Fyxme LLC with records received from third parties in order to
                  enhance our ability to serve you, to tailor our content to
                  you, and to offer you information that we believe may be of
                  interest to you. For example, websites on which we have placed
                  advertisements, such as Google, may tell us which ads about
                  Fyxme LLC you clicked. This is often called "conversion
                  tracking."
                </p>
                <p>
                  In addition, when third parties such as Hirease, Onfido or
                  Checkr.com conduct background checks on service professionals,
                  those third parties share the results of the background check
                  with Fyxme LLC.
                </p>
                <p>
                  We will apply this Privacy Policy to any Personal Information
                  received from third parties, unless we have disclosed
                  otherwise.
                </p>

                <h6>HOW WE USE THE INFORMATION WE COLLECT</h6>
                <p>
                  We use the information we collect to serve our customers,
                  consider applicants, market and promote our services, and
                  improve your experience with Fyxme LLC. Some examples include:
                </p>
                <ul>
                  <li>Scheduling, rescheduling, and cancelling services</li>
                  <li>Rating service professionals</li>
                  <li>Addressing service complaints</li>
                  <li>
                    Communicating with you by email, telephone, or text message,
                    in accordance with your wishes
                  </li>
                  <li>
                    Considering whether to engage service professionals with
                    Fyxme LLC
                  </li>
                  <li>Evaluating job applications to work with Fyxme LLC</li>
                  <li>Improving customer service</li>
                  <li>
                    Sending you marketing and promotional emails, unless you
                    have told us you do not want to receive such emails
                  </li>
                  <li>Troubleshooting technical problems on the Fyxme LLC</li>
                  <li>Responding to questions and feedback</li>
                  <li>Conducting research and analysis</li>
                  <li>
                    Running online or mobile sweepstakes, contents, or other
                    promotions
                  </li>
                  <li>Marketing and advertising products and services</li>
                  <li>
                    Continuously evaluating and improving the online and mobile
                    user experience
                  </li>
                  <li>
                    Preventing, discovering and investigating violations of this
                    Privacy Policy or any applicable terms of service or terms
                    of use for the Mobile Application, and investigating fraud,
                    chargebacks or other matters
                  </li>
                  <li>
                    Contacting you with regard to your use of Fyxme LLC and, in
                    our discretion, changes to Fyxme LLC and/or Fyxme LLC
                    policies
                  </li>
                </ul>
                <p>
                  <strong>Data Retention</strong>
                  <br /> We delete the back-ups of the databases containing your
                  Personal Information after 9 months, unless you request that
                  we delete it earlier.
                </p>
                <h6>III. HOW WE SHARE THE INFORMATION WE COLLECT</h6>
                <p>
                  We do not sell, rent, or trade your Personal Information to
                  third parties other than as disclosed in this Privacy Policy
                  at the time you provide your information. The following are
                  some of the ways we share your information:
                </p>
                <ol>
                  <ul>
                    <strong>
                      a) Third Parties Providing Services on Our Behalf
                    </strong>
                    <br /> Third party companies and individuals provide or
                    facilitate certain aspects of the services offered through
                    Fyxme LLC on our behalf. We may provide these third-party
                    service providers with access to your information, including
                    your Personal Information, so that they can perform these
                    services for us. We require these third-party service
                    providers to provide safeguards for your Personal
                    Information similar to the ones that we provide.
                  </ul>
                </ol>
                <p>
                  The following are some examples of how we share your
                  information with third-party service providers.
                </p>
                <ul>
                  <li>
                    We retain third-party service providers to help us perform
                    data analytics regarding your interactions with Fyxme LLC.
                    For example, Google Analytics (privacy policy&nbsp;here) and
                    Bounce Exchange (privacy policy&nbsp;here) may track what
                    pages users visit on the Site, whether users use any coupon
                    codes, and what services users request to determine how
                    users use the Site.
                  </li>
                  <li>
                    In some cases, these third-party service providers, such as
                    Epsilon, may in turn share your Personal Information, such
                    as your name and email address, with other third parties for
                    their marketing-related purposes. If you wish to opt out of
                    having your Personal Information shared with such third
                    parties, please email{" "}
                    <a href="mailto:legal@fyxme.com">legal@fyxme.com</a>
                  </li>
                  <li>
                    We may disclose your Personal Information to an attorney in
                    the process of obtaining legal advice.
                  </li>
                  <li>
                    When service professionals applying to participate on the
                    Fyxme LLC Site in the United States provide their Social
                    Security numbers for a background check, the Social Security
                    number is transmitted using SSL encryption to the background
                    check service provider. Fyxme LLC also securely provides
                    U.S. service professional's Social Security numbers to the
                    check processor.
                  </li>
                </ul>
                <h5>f) Administrative and Legal Reasons</h5>
                <p>
                  <strong>Required Disclosures:</strong>
                  <br /> We may be required to disclose Personal Information in
                  response to a court order, subpoena, civil discovery request,
                  other legal process, or as otherwise required by law.
                </p>

                <p>
                  <strong>Legal Compliance and Protections:</strong>
                  <br /> We may disclose account and other Personal Information
                  when we believe disclosure is necessary to comply with the law
                  or to protect the rights, property, or safety of Fyxme LLC.
                  our users, or others. This includes exchanging Personal
                  Information with other companies and organizations for fraud
                  prevention and credit risk reduction.
                </p>
                <h5>g) Corporate Transactions</h5>
                <p>
                  We reserve the right to disclose and transfer your
                  information, including your Personal Information:
                </p>
                <ul>
                  <li>
                    To a subsequent owner, co-owner, or operator of Fyxme LLC or
                    successor database.
                  </li>
                  <li>
                    In connection with a corporate merger, consolidation, the
                    sale of substantially all of our membership interests and/or
                    assets or other corporate change, including to any
                    prospective purchasers.
                  </li>
                </ul>
                <h6>CHILDREN'S ONLINE PRIVACY PROTECTION ACT COMPLIANCE</h6>
                <p>
                  We do not collect any information from anyone under 13 years
                  of age. The Fyxme LLC Site, and products and services offered
                  through it, are all directed to people who are at least 13
                  years old or older. If you are under the age of 13, you are
                  not authorized to use the Fyxme LLC Site.
                </p>
                <h6>
                  CALIFORNIA ONLINE PRIVACY PROTECTION ACT COMPLIANCE/YOUR
                  CALIFORNIA PRIVACY RIGHTS
                </h6>
                <p>
                  California residents who use the Fyxme LLC may request that we
                  provide certain information regarding our disclosure of your
                  Personal Information to third parties for their direct
                  marketing purposes. You can make such a request by e-mail to{" "}
                  <a href="mailto:legal@fyxme.com">legal@fyxme.com</a>
                </p>
                <h6>HOW WE PROTECT THE INFORMATION WE COLLECT</h6>
                <p>
                  The security and confidentiality of your Personal Information
                  is important to us. We have implemented technical,
                  administrative, and physical security measures to protect your
                  Personal Information from unauthorized access or disclosure
                  and improper use.
                </p>
                <p>
                  For example, when users book services, the information they
                  input is encrypted through SSL encryption. access to your
                  Personal Information is restricted in our offices. Only
                  employees who need the Personal Information to perform a
                  specific job, for example, sales representatives, managers,
                  and customer service staff, are granted access to Personal
                  Information. All employees with access to Personal Information
                  are kept up to date on our security and privacy practices.
                  After a new policy is added, these employees are notified
                  and/or reminded about the importance we place on privacy, and
                  what they can do to enhance protection for our users' Personal
                  Information.
                </p>
                <p>
                  It is important for you to protect against unauthorized access
                  to your account password and to your computer. Be sure to log
                  out of your account or to close your browser after you have
                  completed your visit to our Site.
                </p>
                <p>
                  Please note that despite our reasonable efforts, no security
                  measure is ever perfect or impenetrable, so we cannot
                  guarantee the security of your Personal Information.
                </p>

                <h6>YOUR CHOICES REGARDING THE INFORMATION WE COLLECT</h6>
                <p>
                  You may contact&nbsp;
                  <a href="mailto:legal@fyxme.com">legal@fyxme.com</a>&nbsp;to
                  update, correct, or delete your Personal Information. You may
                  also update, correct, and delete some of your Personal
                  Information through your account on the Fyxme.
                </p>
                <p>
                  In addition, you may cancel or modify the email communications
                  you have chosen to receive from the Fyxme LLC Site by
                  following the instructions contained in emails from us.
                </p>

                <h6>HAVE QUESTIONS?</h6>
                <p>
                  If you have any questions about this Privacy Policy, we'll do
                  our best to answer them promptly. Here's how to contact us:{" "}
                  <br />
                  Email: <a href="mailto:legal@fyxme.com">legal@fyxme.com</a>
                </p>
                <h6>PRIVACY POLICY UPDATES</h6>
                <p>
                  We may change this Privacy Policy; we will post those changes
                  on this page and update the Privacy Policy modification date
                  above. If we materially change this Privacy Policy in a way
                  that affects how we use or disclose your Personal Information,
                  we will notify you by prominently posting a notice of such
                  changes before making them and by stating the effective date
                  of the changes.
                </p>
                <p>Updated: January 2022</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divider-110 d-none d-lg-block"></div>
    </section>
  );
};

export default Privacy;
